const SeznamPogodbView = () => import("@views/contract-list/contract-list-view.vue");
import PogodbeEdit from "@views/contract-list/contract-edit.vue";
import PogodbeSeznam from "@views/contract-list/contract-list.vue";

export const seznamPogodbRoutes = [
    {
        component: SeznamPogodbView,
        name: "seznam_pogodb_home",
        path: "seznam",
        redirect: { name: "pogodbe_seznam" },
        children: [
            {
                component: PogodbeEdit,
                name: "pogodba_edit",
                path: "pogodba/:id",
                props: true 
            },

            {
                component: PogodbeSeznam,
                name: "pogodbe_seznam",
                path: "pogodbe",
                // beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
                //     const store = useSeznamPogodbStore();

                //     if(from.name != "pogodba_edit"){
                //         store.Filters = ResetFilters();
                //     }
                // }
            },
            
        ]
    },
];